import * as z from "zod";

const merchantCarrierAccount = z.object({
  carrierAccountId: z.string(),
  name: z.string(),
  carrier: z.string(),
  isFedex: z.boolean(),
  enabled: z.boolean(),
});

const accountEnrollment = z.object({
  carrierAccountId: z.string(),
  enabled: z.boolean(),
});

export const getClaimSubmissionSettings = {
  name: "getClaimSubmissionSettings" as const,
  input: z.object({}),
  output: z.object({
    enabled: z.boolean(),
    redoKeepProportion: z.number(),
    accounts: z.array(merchantCarrierAccount),
  }),
};

export const updateClaimSubmissionSettings = {
  name: "updateClaimSubmissionSettings" as const,
  input: z.object({
    enabled: z.boolean().optional(),
    accounts: z.array(accountEnrollment).optional(),
  }),
  output: z.object({
    success: z.boolean(),
    fedexLoaRequired: z.boolean().optional(),
  }),
};

export const recordClaimsFedexLoa = {
  name: "recordClaimsFedexLoa" as const,
  input: z.object({
    carrierAccountId: z.string(),
    documentUrl: z.string().optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
